import { render, staticRenderFns } from "./SvgComponent.vue?vue&type=template&id=39bb85e9&lang=pug&"
import script from "./SvgComponent.vue?vue&type=script&lang=js&"
export * from "./SvgComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports